// Libs
import { ConfigProvider } from 'antd-mobile';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';

// Components
import { AppRouter } from '@app/AppRouter';
import { Loading } from '@app/components/common/Loading/Loading';
import { UpdatePrompt } from '@app/components/common/UpdatePrompt/UpdatePrompt';

// Hooks
// import { useSocketConnection } from '@app/hooks/useSocketConnection';
import { useLanguage } from '@app/hooks/useLanguage';

// Theme
import { ThemeProvider } from '@app/theme/ThemeContext';

// Utils
import { getLocaleByLanguageCode, parseJsonResponse } from '@app/utils/utils';

// Styles
import '@app/App.scss';

function App() {
  // useSocketConnection();

  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();
  // const getAuthStatus = useIsAuthenticated();
  // const isAu = getAuthStatus();

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  // if (loading) {
  //   return <Loading />;
  // }

  return (
    <HelmetProvider>
      <ThemeProvider>
        <ConfigProvider locale={getLocaleByLanguageCode(language)}>
          <AppRouter />
          <UpdatePrompt />
        </ConfigProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
